import React, {useState, useEffect} from 'react';

export const formatAmount = value => {
  if (value === '' || value === '-') return value;

  const stringValue = String(value);
  const parts = stringValue.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];

  const sign = integerPart.startsWith('-') ? '-' : '';
  const digitsOnly = integerPart.replace(/[^\d]/g, '');

  if (digitsOnly === '') {
    if (decimalPart !== undefined) {
      return `${sign}.${decimalPart.replace(/[^\d]/g, '')}`;
    }
    if (stringValue.endsWith('.')) {
      return `${sign}.`;
    }
    return sign;
  }

  const formattedDigits = digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedIntegerPart = sign + formattedDigits;

  if (decimalPart !== undefined) {
    const cleanedDecimalPart = decimalPart.replace(/[^\d]/g, '');
    return `${formattedIntegerPart}.${cleanedDecimalPart}`;
  }

  if (stringValue.endsWith('.')) {
    return `${formattedIntegerPart}.`;
  }

  return formattedIntegerPart;
};

export const isNumeric = value => {
  if (!value || !isNaN(value) || typeof value !== 'string') return false;
  return /^-?\d*\.?\d*$/.test(value?.replace(/,/g, ''));
};

export const SmartInput = ({
  value,
  onChange,
  placeholder = 'Enter value',
  type = 'string',
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState('');

  const isNumberInputType = ['number', 'numeric'].includes(type);

  useEffect(() => {
    const rawValue = value?.toString();
    let formattedValue;

    if (isNumberInputType && !isNaN(rawValue)) {
      formattedValue = formatAmount(rawValue);
    } else {
      formattedValue = rawValue;
    }

    setDisplayValue(formattedValue);
  }, [isNumberInputType, type, value]);

  const handleChange = e => {
    const inputValue = e.target.value || '';
    let formattedValue;

    if (isNumeric(value) && isNumberInputType) {
      formattedValue = formatAmount(inputValue);
    } else {
      formattedValue = inputValue;
    }

    setDisplayValue(formattedValue);
    onChange?.(formattedValue);
  };

  return (
    <input
      {...props}
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      type="text"
    />
  );
};
